import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { BnErrorNoticeComponent } from '../bn-notice/bn-error-notice/bn-error-notice.component';
import { RenewalNoticeComponent } from '../../notices/renewal-notice/renewal-notice.component';
import { BnUpcomingPaymentNoticeComponent } from '../bn-notice/bn-upcoming-payment-notice/bn-upcoming-payment-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { DocumentsDataService } from '@services/data-services/documents-data.service';
import { Router, RouterModule } from '@angular/router';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';
import { Capacitor } from '@capacitor/core';
import { EventService } from '@services/event-service.service';
import { BillingNewService } from '@services/common/billing-new.service';
import { CompanyTypeService } from '@services/_iam/company-type.service';
import { ActionType } from '@models/widget/action-type.enum';
import{ NavigationService } from '@services/navigation.service';
import { InfoTooltipComponent } from '../../../../common/info-tooltip/info-tooltip.component';
import { PolicyTooltipService } from '@services/my-insurance/policy-tooltip.service';
import { PaymentContext, BnPaymentActionsComponent } from '../bn-payment-actions/bn-payment-actions.component';
import { BnOutstandingBalanceComponent } from '../bn-outstanding-balance/bn-outstanding-balance.component';
import { PifDiscountComponent } from '../../../../common/pif-discount/pif-discount.component';
import { MortgageeCustomToolTipComponent } from '../../../../widget/mortgagee-custom-tooltip/mortgagee-custom-tooltip.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BnUpcomingPaymentNoticeComponent, RenewalNoticeComponent, BnErrorNoticeComponent, CustomDateFormatPipe, InfoTooltipComponent, BnPaymentActionsComponent, BnOutstandingBalanceComponent, PifDiscountComponent, MortgageeCustomToolTipComponent],
  selector: 'app-bn-overview',
  templateUrl: './bn-overview.component.html',
  styleUrls: ['./bn-overview.component.scss']
})
export class BnOverviewComponent implements OnInit, OnChanges {
  @Input() policy;
  @ViewChild('payPlanTooltip') payPlanTooltip?: InfoTooltipComponent;
  payNowModal: ModalOptions;
  loading = false;
  outstandingBalance: any;
  currentMinAmtDue: any;
  renewalPolicyPremium: any;
  paymentDate: any;
  nextBill: any;
  autoPay: any;
  isAcmic: boolean;
  invoice: any;
  isNativeApp: boolean;
  company: string;
  expiringLivoPolicyList: any = [];
  isPaidInFull = false;
  hasPriorPif = false;
  showRenewalNonDiscount = false;
  hasMidtermEndorsement: boolean;
  expRenewalDate: string;

  get isMobile(): boolean {
    return this.policyTooltipService.isMobile;
  }
  
   get hasOutstandingBalance(): boolean {
    return this.outstandingBalance > 0;
  }

  constructor(
    private policyDetailsService: PolicyDetailsService,
    private acmicService: AcmicService,
    private documentsDataService: DocumentsDataService,
    private router: Router,
    private paymentService: PaymentServiceService,
    private eventService: EventService,
    private billingNewService: BillingNewService,
    private companyTypeService: CompanyTypeService,
    private navService: NavigationService,
    private policyTooltipService: PolicyTooltipService
  ) { 
    this.isAcmic = this.acmicService.isACMIC();
    this.isNativeApp = false;
  }

  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }

  toggleTooltip(event: Event, tooltip: InfoTooltipComponent){
    event.stopPropagation();
    tooltip.toggle();
  }

  preloadPaymentUsToken(policyNumber: string) {
    if (policyNumber.length === 10) {
      this.paymentService.preloadAndSaveToken(policyNumber);
    }
  }
  onPayByCardBilling(policyNumber, zipCode, minAmount) {
    this.paymentService.setPaymentData(policyNumber, zipCode, minAmount);
    if (policyNumber.length === 10) {
      this.paymentService.redirectToPaymentExpress(
        this.isNativeApp,
        this.isAcmic
      );
    } else {
      this.paymentService.redirectToPayBill(policyNumber, zipCode, minAmount);
    }
  }
  getCheckDigits(policyNumber, checkDigits, company, zipCode, format) {
    if (company == 'TW')
      return policyNumber + ';' + zipCode;
    else if (company == 'ACIC')
      return format.suffix + ';' + format.number
    else
      return policyNumber + checkDigits;
  }
  getPayBillLink(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).url
  }
  getPayBillSource(policy) {
    return this.companyTypeService.getPayBill(policy.residentialAddress.stateCode, policy.company, policy.policynumber.policyNumber).source
  }
  onCreatePaymentForm(accountID, zipCode, minAmount, format, company) {
    const minAmountDueonPolicy = Number(minAmount).toFixed(2);
    let xmlResp;
    if (company.companyName == 'TW') {
      xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else if (company.companyName == 'ACIC') {
      if (company.companyId == '25')
        xmlResp = company.companyId + 'B2C'
      else
        xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else {
      xmlResp = `<MiscellaneousData><UserId>${accountID}</UserId><ZipCode>${zipCode}</ZipCode><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    }
    return xmlResp;
  }
  payNow() {
    this.router.navigate(['billing-new', this.policy?.policynumber?.policyNumber, 'make-a-payment']);
  }

  viewOutStandingBalance(flag) {
    // Intentionally a no-op placeholder.
    void flag;
  }
  viewInvoice(policyNumber, invoiceNumber) {
    this.policyDetailsService
      .getInvoiceByPolicy(policyNumber, invoiceNumber)
      .subscribe(
        (invoice) => {
          if (invoice) {
            this.invoice = invoice;
          }
        },
        () => {
          this.invoice = null;
        }
      );
  }
  onDownloadDocument(documentId) {
    this.documentsDataService.getPolicyDocumentData(
      this.policy?.policynumber?.policyNumber,
      documentId,
      'Invoice_' + this.policy?.policynumber?.policyNumber,
      false
    );
  }
  getLatestScheduledBill() {
    const policyNum = this.policy?.policynumber?.policyNumber ?? '';
    if (this.policy.scheduleBills && (this.isAcmic  || (policyNum.length !== 6 && policyNum.length !== 10))) {
      this.nextBill = this.policy.scheduleBills
        .filter((e) => {
          return e.invoiceState == 'Planned';
        })
        .sort(function compare(a, b) {
          const dateA: any = new Date(a.dateDue);
          const dateB: any = new Date(b.dateDue);
          return dateA - dateB;
        })[0];
    } else {
      this.nextBill = null;
    }
  }
  calculateAmounts(policy) {
    if (policy && policy.billingDetails[0]) {
      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        this.outstandingBalance =
          policy.billingDetails[0].outstandingbalance +
          policy.priorYearBalance.theAmount;
      } else {
        this.outstandingBalance = policy.billingDetails[0].outstandingbalance;
      }

      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        if (
          policy.policyCancellationReason &&
          (policy.policyCancellationReason.toLowerCase() ==
            'pay - non-payment of insurance premium' ||
            policy.policyCancellationReason.toLowerCase() ==
            'fpd - failure to pay deposit') &&
          policy.policyStatus != 'CANCELLED'
        ) {
          this.currentMinAmtDue =
            policy.exitDelinquencyAmount.theAmount +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.policyCancellationEffectiveDate;
        } else {
          this.currentMinAmtDue =
            policy.billingDetails[0].amountStillDue +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.billingDetails[0].paymentDueDate;
        }
      } else if (
        policy.policyCancellationReason &&
        (policy.policyCancellationReason.toLowerCase() ==
          'pay - non-payment of insurance premium' ||
          policy.policyCancellationReason.toLowerCase() ==
          'fpd - failure to pay deposit') &&
        policy.policyStatus != 'CANCELLED'
      ) {
        this.currentMinAmtDue = policy.exitDelinquencyAmount.theAmount;
        this.paymentDate = policy.policyCancellationEffectiveDate;
      } else {
        this.currentMinAmtDue = policy.billingDetails[0].amountStillDue;
        this.paymentDate = policy.billingDetails[0].paymentDueDate;
      }
    }
  }
  
  hasMortgagee(): boolean {
    return (
      this.policy?.billingDetails?.[0]?.mortageeFlag === 'Y' && this.policy?.billingDetails?.[0]?.outstandingbalance > 0
    );
  }

  get paymentContext(): PaymentContext {
    return {
      outstandingBalance: this.outstandingBalance,
      currentMinAmtDue: this.currentMinAmtDue,
      paymentDate: this.paymentDate,
      company: this.company
    };
  }

  callOnInit(policy) {
    this.outstandingBalance = '';
    this.company = this.billingNewService.getCompany([policy]);
    this.calculateAmounts(policy);
    this.viewInvoice(policy?.policynumber?.policyNumber, policy.invoiceNumber);
    this.getLatestScheduledBill();
    const { effDate, expDate } = policy;
    if (effDate) {
      this.autoPay = this.policyDetailsService.getDayDifference(effDate);
    }
    if (expDate) {
      const d = new Date(expDate);
      d.setFullYear(d.getFullYear() + 1);
      this.expRenewalDate = d.toISOString().split('T')[0];
    }
    this.isNative();
    this.preloadPaymentUsToken(policy?.policynumber?.policyNumber);
    this.checkOnPif(policy);    
  }
  
  ngOnInit(): void {
    this.eventService.childEventListner().subscribe(data => {
      if (data?.key === 'initiallize-overview-comp') {
        this.callOnInit(data?.policy);
      }
    })
    this.navService.saveCurrentAction(ActionType.ViewTransactions);
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['policy'] && changes['policy'].currentValue) {
      const newPolicy = changes['policy'].currentValue;
      this.callOnInit(newPolicy);
      this.expiringLivoPolicyList.push(newPolicy);
    }
  }

  private checkOnPif(policy: any){
    this.renewalPolicyPremium = policy?.pifDiscountInfo?.pifEligible 
                                  ? policy?.pifDiscountInfo?.nonDiscountedPremium?.theAmount 
                                  : policy?.totalPolicyPremium?.theAmount;
    
    const isEligible = policy?.pifDiscountInfo?.pifEligible;
    const isDiscountApplied = policy?.pifDiscountInfo?.pifDiscountApplied
    this.isPaidInFull = policy?.pifDiscountInfo?.isPaidInFull;
    this.hasPriorPif = isEligible && !!isDiscountApplied
                    && this.outstandingBalance > 0;
    this.hasMidtermEndorsement = !isEligible && this.isPaidInFull && this.outstandingBalance > 0
    this.showRenewalNonDiscount = policy.hasPriorYearBalance || (policy?.pifDiscountInfo?.isPifDiscountEligible && !this.isPaidInFull)    
  }
}